import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UilabMatChipsModule } from '@uilab/ng-mat-components';

@Component({
    selector: 'ds-lozenge',
    templateUrl: './lozenge.component.html',
    styleUrls: ['./lozenge.component.scss'],
    imports: [UilabMatChipsModule],
    encapsulation: ViewEncapsulation.None,
})
export class LozengeComponent {
    @Input() status!: 'error' | 'information' | 'warning' | 'success';
}
